import { render, staticRenderFns, recyclableRender, components } from "./index.vue?vue&type=template&id=93697a60&scoped=true&"
var renderjs
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=93697a60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93697a60",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/orderDetails/index.vue"
export default component.exports